export default __webpack_public_path__ + "static/20251219-241ca596dc2acc792282d7de53ae9129.png";